const BODY_LANGUAGE_TYPES = {
  fr: "fr"
}

export default BODY_LANGUAGE_TYPES
